const styles = {
  planeContainerStyle: {
    position: "absolute",
    opacity: 0
  }
};

export default styles;
